<template>
    <div class="tabView">
        <div :class="active.text === item.text ? 'active' : ''" v-for="(item, index) in list" :key="index" @click="onTab(item)">{{item.text}}</div>
    </div>
</template>

<script>
    /*
    * tab组件
    * */
    export default {
        name: "Tab",
        props: {
            activeTab: {
                type: Object,
                default: 0
            },
            list: {
                type: Array,
                default: []
            }
        },
        watch: {
            activeTab: {
                handler(obj) {
                    this.active = obj;
                },
                immediate: true,
            }
        },
        data() {
            return {
                active: {}
            }
        },
        methods: {
            onTab(item) {
                this.active = item;
                this.$emit('click', item);
            }
        }
    }
</script>

<style lang='less' scoped>
    .tabView {
        display: flex;
        align-items: center;
        height: 12.27vw;
        padding: 0 4.4vw;
        div {
            margin-right: 5vw;
            font-size: 3.2vw;
            color: #333333;
            &.active {
                padding-bottom: 1vw;
                border-bottom: 0.53vw solid #82c1ff;
                font-size: 4vw;
                color: #333333;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Tab.vue